export default __webpack_public_path__ + "static/media/MiniaturaMaternal.fc08e0f6.jpg";